export const QUOTA_SECTION_TITLE = 'Quota';
export const SALARY_AND_SALES_PROCESS_SECTION_TITLE = 'Salary & sales process';
